<template>
    <div v-html="print_content" class="show-on-print" id="application">
    </div>
</template>

<script>
    export default {
        name: "ApplicationForm",
        computed: {
            print_content() {
                let visa_request = this.$store.state.VisaRequestSingle.visaRequest;
                return visa_request.application_form
            }

        }
    }
</script>

